import { sendPost } from '../http.js'
const api = {
	'indextrendproduct': {
        url: '/user/data/center/indextrendproduct'
    },
    'conversionandtrend': {
        url: '/user/data/center/conversionandtrend'
    },
    'daydata': {
        url: '/user/data/center/daydata'
    },
    'datapandect': {
        url: '/user/data/center/datapandect'
    },
    'indextrend': {
        url: '/user/data/center/indextrend'
    },
    'merchantAddhtml': {
        url: '/merchant/addhtml'
    },
    'merchantStatus': {
        url: '/merchant/status'
    },
    'merchantTax': {
        url: '/merchant/tax',
        mutationsName: 'changeTax',
        stateName: 'tax',
        stateDefaultName: '',
        getStateName: 'tax_status'
    },
    'dycodeincomerankinglist': {
        url: '/user/data/center/dycodeincomerankinglist'
    },
    'getCourseSalesInfo': {
        url: '/user/data/center/product/sales'
    },
    'getCourseSalesInfoV2API': { // 课程销量列表数据v2
        url: '/user/data/center/product/salesv2'
    },
    'getClassListAPI': { // 获取课程列表
        url: '/user/data/center/product/listproduct'
    },
    'getSalesTrendAPI': { // 获取课程销量图表数据
        url: '/user/data/center/product/salestrend'
    },
    'analysis': {
        url: '/statistics/analysis'
    },
    'merchantList': {
        url: '/merchant/list'
    },
    'addSubMerchant': {
        url: '/merchant/add_sub_merchant_page '
    },
    'getProductsPvListAPI': { // 获取课程章节访问列表
        url: '/user/data/center/product_show/pv'
    },
    'getShowProductsAPI': { // 获取有访问章节的课程
        url: '/user/data/center/get_show_product_ids'
    }
}
const requestFunObj = {}
for (const key in api) {
    requestFunObj[key]  = {
        ...api[key],
        requestFun:(params, method='post', headers) => {
            return sendPost(api[key].url, params, method, headers)
        }
    } 
}
export default requestFunObj
